cv.PaginatePublicBehavior = Marionette.Behavior.extend({
    // you can set default options
    // just like you can in your Backbone Models
    // they will be overriden if you pass in an option with the same key
    defaults: {
    },

    // behaviors have events that are bound to the views DOM
    events: {
      'click .pagination .prev' : 'previousPage',
      'click .pagination .next' : 'nextPage'
    },

    collectionEvents: {
      'reset' : 'collectionReset',
      'request' : 'collectionRequest',
      'sync' : 'collectionSync'
    },

    collectionReset: function(collection){
      if(this.$('.pagination').length == 0){
        this.view.$childViewContainer.before(cv.Templates['partials/pagination']());
        this.view.$childViewContainer.after(cv.Templates['partials/pagination']());
      }

      this.$('.pagination .caption').html(collection.caption).hide().fadeIn();
      if(collection.params.offset + collection.params.limit < collection.num_records){
        this.$('.pagination a.next').css('display','inline-flex');
      }else if(collection.params.offset + collection.params.limit > collection.num_records){
        this.$('.pagination a.next').css('display','none');
      }
      if(collection.params.offset > 0){
        this.$('.pagination a.prev').css('display','inline-flex');
      }else{
        this.$('.pagination a.prev').css('display','none');
      }
    },

    collectionRequest: function(collection){
      console.log('Fetching collection...');

      this.view.$childViewContainer.html(cv.Templates['partials/loader']());
    },

    collectionSync: function(collection){
      console.log('Fetch collection complete.');

      this.$('.loader').remove();
      this.view.$childViewContainer.css('min-height', this.view.$childViewContainer.outerHeight());
      this.view.$childViewContainer.hide().fadeIn();
    },

    previousPage: function(e){
      e.preventDefault();

      this.view.collection.previousPage();
    },

    nextPage: function(e){
      e.preventDefault();

      this.view.collection.nextPage();
    }
});